export const getFilteredMenuItems = (rolesArray) => {
    const officeStaff = rolesArray.some(role => role.roles === "office-staff");

    const menuItems = [
        { id: 1, label: "menuitems.dashboard.text", icon: "uil-home-alt", link: "/" },
        { id: 86, label: "menuitems.chat.text", icon: "mdi mdi-chat-outline", link: "/chat" },
        { id: 87, label: "menuitems.odbMaps.text", icon: "mdi mdi-map", link: "/coverage-maps" },
        {
            id: 88,
            label: "menuitems.customer.text",
            icon: "fas fa-users",
            subItems: [
                { id: 89, label: "menuitems.customer.list.registrasi", link: "/customer/registration" },
                { id: 90, label: "menuitems.customer.list.applicant", link: "/customer/applicant" },
                { id: 91, label: "menuitems.customer.list.invoicePelanggan", link: "/invoices/list" },
                { id: 92, label: "menuitems.customer.list.listPelanggan", link: "/customer/customer-list" }
            ]
        },
        {
            id: 89,
            label: "menuitems.ticket.text",
            icon: "uil-ticket",
            link: "/ticket",
            subItems: [
                { id: 92, label: "menuitems.ticket.list.dashboard", link: "/dashboard-ticket" },
                { id: 93, label: "menuitems.ticket.list.create", link: "/ticket" },
            ]
        }
    ];

    if (officeStaff) {
        const filteredMenu = menuItems.filter(item => ![].includes(item.id));
        console.log('Filtered menu:', filteredMenu);
        return filteredMenu; 
    }

    return menuItems;
};
